// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Event\ApiEvent.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { AutomationSystem, AutomationSystemData, AutomationSystemOptions } from 'data/models/AutomationSystem';
import { BerthRelevance, BerthRelevanceData, BerthRelevanceOptions } from 'data/models/BerthRelevance';
import { BerthReservationSelf, BerthReservationSelfData, BerthReservationSelfOptions } from 'data/models/BerthReservationSelf';
import { BerthReservationVersion, BerthReservationVersionData, BerthReservationVersionOptions } from 'data/models/BerthReservationVersion';
import { Change, ChangeData, ChangeOptions } from 'data/models/Change';
import { Comment, CommentData, CommentOptions } from 'data/models/Comment';
import { CoordinationCardRelevance, CoordinationCardRelevanceData, CoordinationCardRelevanceOptions } from 'data/models/CoordinationCardRelevance';
import { CoordinationCardSelf, CoordinationCardSelfData, CoordinationCardSelfOptions } from 'data/models/CoordinationCardSelf';
import { CoordinationCardVersion, CoordinationCardVersionData, CoordinationCardVersionOptions } from 'data/models/CoordinationCardVersion';
import { DomainRelevance, DomainRelevanceData, DomainRelevanceOptions } from 'data/models/DomainRelevance';
import { GeoActivity, GeoActivityData, GeoActivityOptions } from 'data/models/GeoActivity';
import { ItineraryPointSelf, ItineraryPointSelfData, ItineraryPointSelfOptions } from 'data/models/ItineraryPointSelf';
import { ItineraryPointVersion, ItineraryPointVersionData, ItineraryPointVersionOptions } from 'data/models/ItineraryPointVersion';
import { JobOrderSelf, JobOrderSelfData, JobOrderSelfOptions } from 'data/models/JobOrderSelf';
import { JobOrderVersion, JobOrderVersionData, JobOrderVersionOptions } from 'data/models/JobOrderVersion';
import { LogEvent, LogEventData, LogEventOptions } from 'data/models/LogEvent';
import { Notification, NotificationData, NotificationOptions } from 'data/models/Notification';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { PilotJobOrderCancellation, PilotJobOrderCancellationData, PilotJobOrderCancellationOptions } from 'data/models/PilotJobOrderCancellation';
import { PilotJobOrderChange, PilotJobOrderChangeData, PilotJobOrderChangeOptions } from 'data/models/PilotJobOrderChange';
import { PilotJobOrderRelevance, PilotJobOrderRelevanceData, PilotJobOrderRelevanceOptions } from 'data/models/PilotJobOrderRelevance';
import { PilotShiphandlingNote, PilotShiphandlingNoteData, PilotShiphandlingNoteOptions } from 'data/models/PilotShiphandlingNote';
import { PortCallChange, PortCallChangeData, PortCallChangeOptions } from 'data/models/PortCallChange';
import { PortCallDeletion, PortCallDeletionData, PortCallDeletionOptions } from 'data/models/PortCallDeletion';
import { PortCallSelf, PortCallSelfData, PortCallSelfOptions } from 'data/models/PortCallSelf';
import { PortCallVersion, PortCallVersionData, PortCallVersionOptions } from 'data/models/PortCallVersion';
import { PortCDMRelevance, PortCDMRelevanceData, PortCDMRelevanceOptions } from 'data/models/PortCDMRelevance';
import { RecurringBatchChange, RecurringBatchChangeData, RecurringBatchChangeOptions } from 'data/models/RecurringBatchChange';
import { RecurringBatchDeletion, RecurringBatchDeletionData, RecurringBatchDeletionOptions } from 'data/models/RecurringBatchDeletion';
import { RecurringBatchSelf, RecurringBatchSelfData, RecurringBatchSelfOptions } from 'data/models/RecurringBatchSelf';
import { RecurringBatchVersion, RecurringBatchVersionData, RecurringBatchVersionOptions } from 'data/models/RecurringBatchVersion';
import { TopicCardChange, TopicCardChangeData, TopicCardChangeOptions } from 'data/models/TopicCardChange';
import { VesselChange, VesselChangeData, VesselChangeOptions } from 'data/models/VesselChange';

// EventData is the class that Event serializes to/from
export interface EventData {
    Id : number;
	
    About : ChangeData | null;
    AboutId : number;
    Automation : AutomationSystemData | null;
    AutomationId : number | null;
    BerthReservation : BerthReservationSelfData | null;
    BerthReservationId : number | null;
    BerthReservationReferenceVersion : BerthReservationVersionData | null;
    BerthReservationVersion : BerthReservationVersionData | null;
    Berths : BerthRelevanceData[] | null;
    Comment : CommentData | null;
    Comments : CommentData[] | null;
    CommentsUrl : string | null;
    CoordinationCard : CoordinationCardSelfData | null;
    CoordinationCardId : number | null;
    CoordinationCardReferenceVersion : CoordinationCardVersionData | null;
    CoordinationCards : CoordinationCardRelevanceData[] | null;
    CoordinationCardVersion : CoordinationCardVersionData | null;
    Created : ChangeData | null;
    CreatedId : number;
    Domains : DomainRelevanceData[] | null;
    GeoActivity : GeoActivityData | null;
    ItineraryPoint : ItineraryPointSelfData | null;
    ItineraryPointId : number | null;
    ItineraryPointReferenceVersion : ItineraryPointVersionData | null;
    ItineraryPointVersion : ItineraryPointVersionData | null;
    JobOrder : JobOrderSelfData | null;
    JobOrderId : number | null;
    JobOrderReferenceVersion : JobOrderVersionData | null;
    JobOrderVersion : JobOrderVersionData | null;
    Notifications : NotificationData[] | null;
    PilotJobOrderCancellation : PilotJobOrderCancellationData | null;
    PilotJobOrderChange : PilotJobOrderChangeData | null;
    PilotJobOrders : PilotJobOrderRelevanceData[] | null;
    PilotShiphandlingNote : PilotShiphandlingNoteData | null;
    PortCall : PortCallSelfData | null;
    PortCallChange : PortCallChangeData | null;
    PortCallDeletion : PortCallDeletionData | null;
    PortCallId : number | null;
    PortCallReferenceVersion : PortCallVersionData | null;
    PortCalls : LogEventData[] | null;
    PortCallVersion : PortCallVersionData | null;
    PortCDMRelevances : PortCDMRelevanceData[] | null;
    RecurringBatch : RecurringBatchSelfData | null;
    RecurringBatchChange : RecurringBatchChangeData | null;
    RecurringBatchDeletion : RecurringBatchDeletionData | null;
    RecurringBatchId : number | null;
    RecurringBatchReferenceVersion : RecurringBatchVersionData | null;
    RecurringBatchVersion : RecurringBatchVersionData | null;
    Reference : ChangeData | null;
    ReferenceId : number | null;
    TopicCardChange : TopicCardChangeData | null;
    User : PCUserData | null;
    UserId : number | null;
    VesselChange : VesselChangeData | null;
	
    Data : string | null;
    Date : /* ISO8601 */ string;
    Type : string | null;
}

// EventOptions is the class which may be passed to the Event constructor to define optional initial data values
export interface EventOptions {
    Id : number;
	
    About? : ChangeOptions | null;
    AboutId? : number;
    Automation? : AutomationSystemOptions | null;
    AutomationId? : number | null;
    BerthReservation? : BerthReservationSelfOptions | null;
    BerthReservationId? : number | null;
    BerthReservationReferenceVersion? : BerthReservationVersionOptions | null;
    BerthReservationVersion? : BerthReservationVersionOptions | null;
    Berths? : BerthRelevanceOptions[] | null;
    Comment? : CommentOptions | null;
    Comments? : CommentOptions[] | null;
    CommentsUrl? : string | null;
    CoordinationCard? : CoordinationCardSelfOptions | null;
    CoordinationCardId? : number | null;
    CoordinationCardReferenceVersion? : CoordinationCardVersionOptions | null;
    CoordinationCards? : CoordinationCardRelevanceOptions[] | null;
    CoordinationCardVersion? : CoordinationCardVersionOptions | null;
    Created? : ChangeOptions | null;
    CreatedId? : number;
    Domains? : DomainRelevanceOptions[] | null;
    GeoActivity? : GeoActivityOptions | null;
    ItineraryPoint? : ItineraryPointSelfOptions | null;
    ItineraryPointId? : number | null;
    ItineraryPointReferenceVersion? : ItineraryPointVersionOptions | null;
    ItineraryPointVersion? : ItineraryPointVersionOptions | null;
    JobOrder? : JobOrderSelfOptions | null;
    JobOrderId? : number | null;
    JobOrderReferenceVersion? : JobOrderVersionOptions | null;
    JobOrderVersion? : JobOrderVersionOptions | null;
    Notifications? : NotificationOptions[] | null;
    PilotJobOrderCancellation? : PilotJobOrderCancellationOptions | null;
    PilotJobOrderChange? : PilotJobOrderChangeOptions | null;
    PilotJobOrders? : PilotJobOrderRelevanceOptions[] | null;
    PilotShiphandlingNote? : PilotShiphandlingNoteOptions | null;
    PortCall? : PortCallSelfOptions | null;
    PortCallChange? : PortCallChangeOptions | null;
    PortCallDeletion? : PortCallDeletionOptions | null;
    PortCallId? : number | null;
    PortCallReferenceVersion? : PortCallVersionOptions | null;
    PortCalls? : LogEventOptions[] | null;
    PortCallVersion? : PortCallVersionOptions | null;
    PortCDMRelevances? : PortCDMRelevanceOptions[] | null;
    RecurringBatch? : RecurringBatchSelfOptions | null;
    RecurringBatchChange? : RecurringBatchChangeOptions | null;
    RecurringBatchDeletion? : RecurringBatchDeletionOptions | null;
    RecurringBatchId? : number | null;
    RecurringBatchReferenceVersion? : RecurringBatchVersionOptions | null;
    RecurringBatchVersion? : RecurringBatchVersionOptions | null;
    Reference? : ChangeOptions | null;
    ReferenceId? : number | null;
    TopicCardChange? : TopicCardChangeOptions | null;
    User? : PCUserOptions | null;
    UserId? : number | null;
    VesselChange? : VesselChangeOptions | null;
	
    Data? : string | null;
    Date? : /* ISO8601 */ string;
    Type? : string | null;
}

export class Event {
    public Id : DataSignal<number>;
	
    public About : DataSignal<Change | null>;
    public AboutId : DataSignal<number>;
    public Automation : DataSignal<AutomationSystem | null>;
    public AutomationId : DataSignal<number | null>;
    public BerthReservation : DataSignal<BerthReservationSelf | null>;
    public BerthReservationId : DataSignal<number | null>;
    public BerthReservationReferenceVersion : DataSignal<BerthReservationVersion | null>;
    public BerthReservationVersion : DataSignal<BerthReservationVersion | null>;
    public Berths : SDataArray<BerthRelevance>;
    public Comment : DataSignal<Comment | null>;
    public Comments : SDataArray<Comment>;
    public CommentsUrl : DataSignal<string | null>;
    public CoordinationCard : DataSignal<CoordinationCardSelf | null>;
    public CoordinationCardId : DataSignal<number | null>;
    public CoordinationCardReferenceVersion : DataSignal<CoordinationCardVersion | null>;
    public CoordinationCards : SDataArray<CoordinationCardRelevance>;
    public CoordinationCardVersion : DataSignal<CoordinationCardVersion | null>;
    public Created : DataSignal<Change | null>;
    public CreatedId : DataSignal<number>;
    public Domains : SDataArray<DomainRelevance>;
    public GeoActivity : DataSignal<GeoActivity | null>;
    public ItineraryPoint : DataSignal<ItineraryPointSelf | null>;
    public ItineraryPointId : DataSignal<number | null>;
    public ItineraryPointReferenceVersion : DataSignal<ItineraryPointVersion | null>;
    public ItineraryPointVersion : DataSignal<ItineraryPointVersion | null>;
    public JobOrder : DataSignal<JobOrderSelf | null>;
    public JobOrderId : DataSignal<number | null>;
    public JobOrderReferenceVersion : DataSignal<JobOrderVersion | null>;
    public JobOrderVersion : DataSignal<JobOrderVersion | null>;
    public Notifications : SDataArray<Notification>;
    public PilotJobOrderCancellation : DataSignal<PilotJobOrderCancellation | null>;
    public PilotJobOrderChange : DataSignal<PilotJobOrderChange | null>;
    public PilotJobOrders : SDataArray<PilotJobOrderRelevance>;
    public PilotShiphandlingNote : DataSignal<PilotShiphandlingNote | null>;
    public PortCall : DataSignal<PortCallSelf | null>;
    public PortCallChange : DataSignal<PortCallChange | null>;
    public PortCallDeletion : DataSignal<PortCallDeletion | null>;
    public PortCallId : DataSignal<number | null>;
    public PortCallReferenceVersion : DataSignal<PortCallVersion | null>;
    public PortCalls : SDataArray<LogEvent>;
    public PortCallVersion : DataSignal<PortCallVersion | null>;
    public PortCDMRelevances : SDataArray<PortCDMRelevance>;
    public RecurringBatch : DataSignal<RecurringBatchSelf | null>;
    public RecurringBatchChange : DataSignal<RecurringBatchChange | null>;
    public RecurringBatchDeletion : DataSignal<RecurringBatchDeletion | null>;
    public RecurringBatchId : DataSignal<number | null>;
    public RecurringBatchReferenceVersion : DataSignal<RecurringBatchVersion | null>;
    public RecurringBatchVersion : DataSignal<RecurringBatchVersion | null>;
    public Reference : DataSignal<Change | null>;
    public ReferenceId : DataSignal<number | null>;
    public TopicCardChange : DataSignal<TopicCardChange | null>;
    public User : DataSignal<PCUser | null>;
    public UserId : DataSignal<number | null>;
    public VesselChange : DataSignal<VesselChange | null>;
	
    public Data : DataSignal<string | null>;
    public Date : DataSignal<TZDate>;
    public Type : DataSignal<string | null>;

    constructor();
    constructor(data : EventOptions);
    constructor(data: EventOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.About = S.value<Change | null>(null);
        this.AboutId = jsonableObservable(S.value<number>(data && data.AboutId !== undefined ? data.AboutId : 0));
        this.Automation = S.value<AutomationSystem | null>(null);
        this.AutomationId = jsonableObservable(S.value<number | null>(data && data.AutomationId !== undefined ? data.AutomationId : null));
        this.BerthReservation = S.value<BerthReservationSelf | null>(null);
        this.BerthReservationId = jsonableObservable(S.value<number | null>(data && data.BerthReservationId !== undefined ? data.BerthReservationId : null));
        this.BerthReservationReferenceVersion = S.value<BerthReservationVersion | null>(null);
        this.BerthReservationVersion = S.value<BerthReservationVersion | null>(null);
        this.Berths = SArray<BerthRelevance>([]);
        this.Comment = S.value<Comment | null>(null);
        this.Comments = SArray<Comment>([]);
        this.CommentsUrl = jsonableObservable(S.value<string | null>(data && data.CommentsUrl !== undefined ? data.CommentsUrl : null));
        this.CoordinationCard = S.value<CoordinationCardSelf | null>(null);
        this.CoordinationCardId = jsonableObservable(S.value<number | null>(data && data.CoordinationCardId !== undefined ? data.CoordinationCardId : null));
        this.CoordinationCardReferenceVersion = S.value<CoordinationCardVersion | null>(null);
        this.CoordinationCards = SArray<CoordinationCardRelevance>([]);
        this.CoordinationCardVersion = S.value<CoordinationCardVersion | null>(null);
        this.Created = S.value<Change | null>(null);
        this.CreatedId = jsonableObservable(S.value<number>(data && data.CreatedId !== undefined ? data.CreatedId : 0));
        this.Domains = SArray<DomainRelevance>([]);
        this.GeoActivity = S.value<GeoActivity | null>(null);
        this.ItineraryPoint = S.value<ItineraryPointSelf | null>(null);
        this.ItineraryPointId = jsonableObservable(S.value<number | null>(data && data.ItineraryPointId !== undefined ? data.ItineraryPointId : null));
        this.ItineraryPointReferenceVersion = S.value<ItineraryPointVersion | null>(null);
        this.ItineraryPointVersion = S.value<ItineraryPointVersion | null>(null);
        this.JobOrder = S.value<JobOrderSelf | null>(null);
        this.JobOrderId = jsonableObservable(S.value<number | null>(data && data.JobOrderId !== undefined ? data.JobOrderId : null));
        this.JobOrderReferenceVersion = S.value<JobOrderVersion | null>(null);
        this.JobOrderVersion = S.value<JobOrderVersion | null>(null);
        this.Notifications = SArray<Notification>([]);
        this.PilotJobOrderCancellation = S.value<PilotJobOrderCancellation | null>(null);
        this.PilotJobOrderChange = S.value<PilotJobOrderChange | null>(null);
        this.PilotJobOrders = SArray<PilotJobOrderRelevance>([]);
        this.PilotShiphandlingNote = S.value<PilotShiphandlingNote | null>(null);
        this.PortCall = S.value<PortCallSelf | null>(null);
        this.PortCallChange = S.value<PortCallChange | null>(null);
        this.PortCallDeletion = S.value<PortCallDeletion | null>(null);
        this.PortCallId = jsonableObservable(S.value<number | null>(data && data.PortCallId !== undefined ? data.PortCallId : null));
        this.PortCallReferenceVersion = S.value<PortCallVersion | null>(null);
        this.PortCalls = SArray<LogEvent>([]);
        this.PortCallVersion = S.value<PortCallVersion | null>(null);
        this.PortCDMRelevances = SArray<PortCDMRelevance>([]);
        this.RecurringBatch = S.value<RecurringBatchSelf | null>(null);
        this.RecurringBatchChange = S.value<RecurringBatchChange | null>(null);
        this.RecurringBatchDeletion = S.value<RecurringBatchDeletion | null>(null);
        this.RecurringBatchId = jsonableObservable(S.value<number | null>(data && data.RecurringBatchId !== undefined ? data.RecurringBatchId : null));
        this.RecurringBatchReferenceVersion = S.value<RecurringBatchVersion | null>(null);
        this.RecurringBatchVersion = S.value<RecurringBatchVersion | null>(null);
        this.Reference = S.value<Change | null>(null);
        this.ReferenceId = jsonableObservable(S.value<number | null>(data && data.ReferenceId !== undefined ? data.ReferenceId : null));
        this.TopicCardChange = S.value<TopicCardChange | null>(null);
        this.User = S.value<PCUser | null>(null);
        this.UserId = jsonableObservable(S.value<number | null>(data && data.UserId !== undefined ? data.UserId : null));
        this.VesselChange = S.value<VesselChange | null>(null);
	    
        this.Data = jsonableObservable(S.value<string | null>(data && data.Data !== undefined ? data.Data : null));
        this.Date = jsonableObservable(S.value<TZDate>(data && data.Date !== undefined ? new TZDate(data.Date) : new TZDate(0), TZDate.eq));
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
    }

    static key(obj : Event) {
        return obj.Id();
    }
    
    static dataKey(obj : EventOptions) {
        return obj.Id;
    }

    static update(obj : Event, data : EventOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.AboutId !== undefined) obj.AboutId(data.AboutId);
            if (data.AutomationId !== undefined) obj.AutomationId(data.AutomationId);
            if (data.BerthReservationId !== undefined) obj.BerthReservationId(data.BerthReservationId);
            if (data.CommentsUrl !== undefined) obj.CommentsUrl(data.CommentsUrl);
            if (data.CoordinationCardId !== undefined) obj.CoordinationCardId(data.CoordinationCardId);
            if (data.CreatedId !== undefined) obj.CreatedId(data.CreatedId);
            if (data.ItineraryPointId !== undefined) obj.ItineraryPointId(data.ItineraryPointId);
            if (data.JobOrderId !== undefined) obj.JobOrderId(data.JobOrderId);
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.RecurringBatchId !== undefined) obj.RecurringBatchId(data.RecurringBatchId);
            if (data.ReferenceId !== undefined) obj.ReferenceId(data.ReferenceId);
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
            if (data.Data !== undefined) obj.Data(data.Data);
            if (data.Date !== undefined) obj.Date(new TZDate(data.Date));
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Event.ts